<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h5>Discount Search</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5" style="padding-top:10px;">
        <form ref="searchForm" @submit.prevent="adSearch">
          <input
            class="search-field"
            placeholder="Search by Keyword"
            v-model="keywordSearchField"
            v-on:keyup.enter="adSearch"
          />
        </form>
      </div>

      <div class="col-md-5">
        <select v-model="adSort" class="custom-select" @change="updateSort">

          <option
            v-for="option in ['newest','oldest', 'most likes','most comments', 'most views']"
            :value="option"
            :key="option"
          >{{ option }}</option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <p-button @click="adSearch">Search</p-button>
      </div>
    </div>
    <div class="row" v-if="paginationArray.length > 1">
      <div class="col-md-12">
        <p-button v-if="prevPage !==null" @click="pageNavigation(prevPage)">
          <i class="fas fa-angle-double-left"></i> prev
        </p-button>
        <span v-for="page in paginationArray" :key="page">
          <p-button v-if="page==currentPage" @click="pageNavigation(page)">{{page}}</p-button>
          <p-button v-else @click="pageNavigation(page)">{{page}}</p-button>
        </span>
        <p-button v-if="nextPage!==null" @click="pageNavigation(nextPage)">
          <i class="fas fa-angle-double-right"></i> next
        </p-button>
      </div>
    </div>
    <div v-if="adList.length > 0">
      <hr />

      <div class="row">
        <div class="col-md-5">
          <h4
            style="margin-top:5px; margin-left:10px;"
            v-if="typeof $route.query.q !='undefined' && $route.query.q !=''"
          >Results for @{{$route.query.q}}</h4>
          <p
            style="padding-left:15px;"
          >{{searchData.count}} results Page {{currentPage}} of {{pageCount}}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 col-lg-3" v-for="post in adList" :key="post.shortcode">
          <div
            class="hovereffect post-click"
            @click="$router.push(`/sales/ad-detail/`+ post.shortcode)"
          >
            <span style="width:100%">
              <img
                :src="post.imageUrlCache"
                v-if="typeof post.imageUrlCache !=='undefined'"
                alt
                class="img-responsive"
              />
              <img v-else :src="post.imageUrl" @error="imageLoadCache(post.shortcode)" />
            </span>
            <div class="overlay">
              <div class="overlay-stats">
                <div style="padding:15px;">
                  <i v-if="post.mediaType=='carousel'" class="fas fa-photo-video"></i>
                  <i v-if="post.mediaType=='image'" class="far fa-image"></i>
                  <i v-if="post.mediaType=='video'" class="fas fa-video"></i>
                </div>

                <p v-if="typeof post.viewCount  !=='undefined'">views: {{post.viewCountString}}</p>
                <p v-if="typeof post.likeCount  !=='undefined'">likes: {{post.likeCountString}}</p>
                <p
                  v-if="typeof post.commentCount  !=='undefined'"
                >comments: {{post.commentCountString}}</p>

                <p class="icon-links">VIEW DETAIL</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="paginationArray.length > 1">
        <div class="col-md-12">
          <p-button v-if="prevPage !==null" @click="pageNavigation(prevPage)">
            <i class="fas fa-angle-double-left"></i> prev
          </p-button>
          <span v-for="page in paginationArray" :key="page">
            <p-button v-if="page==currentPage" @click="pageNavigation(page)">{{page}}</p-button>
            <p-button v-else @click="pageNavigation(page)">{{page}}</p-button>
          </span>
          <p-button v-if="nextPage!==null" @click="pageNavigation(nextPage)">
            <i class="fas fa-angle-double-right"></i> next
          </p-button>
        </div>
      </div>
    </div>
    <div v-else-if="searchActive== true">
      <div class="lds-dual-ring"></div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import _ from "underscore";
import { adSearchApi, adCacheApi } from "@/config/appSettings";
import IgProfile from "@/libs/ig/profileData";
import { Badge, Modal, Pagination } from "@/components/UIComponents";

import { mapGetters, mapActions } from "vuex";
import { VueAutosuggest } from "vue-autosuggest";
export default {
  components: {
    [Badge.name]: Badge,
    VueAutosuggest,
    Modal,
    [Pagination.name]: Pagination,
  },
  data: () => ({
    auth: null,
    loadingOverlay: false,
    campaign: null,
    postList: null,
    visibleList: [],
    currentInstagram: null,
    campaigns: null,
    isInfluencer: null,
    isClient: null,
    searchData: null,
    adList: [],
    adSort: "newest",
    searchHashtag: null,
    searchKeyword: null,
    searchQuery: null,
    searchField: null,
    hashtagProps: null,
    hashtagSearchField: null,
    searchActive: false,
    showPost: false,
    postShortcode: null,
    postEmbedCode: null,
    pageCount: null,
    adCount: null,
    currentPage: 1,
    paginationArray: [],
    nextPage: null,
    prevPage: null,
  }),
  name: "InfluencerPostList",
  methods: {
    async setHashtagValue(val) {
      return val.name;
    },
    async navigateDownload(shortcode) {
      this.showPost = false;
      this.$router.push("/instagram/download/" + shortcode);
    },
    async closeModal(val) {
      this.showPost = false;
      this.postShortcode = null;
      this.postEmbedCode = null;
      console.log("CLOSING...");
    },
    async badgeSearch(hashtag) {
      this.postList = null;
      this.$router.push(`/instagram/search/content?q=${hashtag}`);
      await this.loadPosts();
    },
    async updateSort() {
      try {
        let newUrl = `/sales/ad-search`;
        let queryArray = [];
        if (typeof this.$route.query.q !== "undefined") {
          queryArray.push(`q=${this.$route.query.q}`);

          let searchType = this.$route.query.type;
          if (typeof searchType == "undefined") {
            searchType = "keyword";
          }
          if (searchType == "undefined") {
            searchType = "keyword";
          }
          queryArray.push(`type=${searchType}`);
        }

        if (typeof this.$route.query.page !== "undefined") {
          queryArray.push(`page=${this.$route.query.page}`);
        }
        let sortQuery;
        if (this.adSort == "newest") {
        }
        if (this.adSort == "oldest") {
          queryArray.push(`sort=oldest`);
        }
        if (this.adSort == "newest") {
          queryArray.push(`sort=newest`);
        }
        if (this.adSort == "most likes") {
          queryArray.push(`sort=likes`);
        }
        if (this.adSort == "most comments") {
          queryArray.push(`sort=comments`);
        }
        if (this.adSort == "most views") {
          queryArray.push(`sort=views`);
        }
        if (queryArray.length > 0) {
          let queryString = queryArray.join("&");
          newUrl = `${newUrl}/?${queryString}`;
        }
        this.$router.push(newUrl);
        this.adSearch();
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async pageNavigation(navPage) {
      try {
        navPage = Number(navPage);
        console.log("NAVIGATING NEXT PAGE:", navPage);
        let newUrl = `/sales/ad-search`;
        let queryArray = [];
        if (typeof this.$route.query.q !== "undefined") {
          queryArray.push(`q=${this.$route.query.q}`);

          let searchType = this.$route.query.type;
          if (typeof searchType == "undefined") {
            searchType = "keyword";
          }
          if (searchType == "undefined") {
            searchType = "keyword";
          }
          queryArray.push(`type=${searchType}`);
        }

        if (!isNaN(navPage)) {
          console.log("NAV PAGING!");
          queryArray.push(`page=${navPage}`);
        }
        let sortQuery;
        if (this.adSort == "newest") {
        }
        if (this.adSort == "oldest") {
          queryArray.push(`sort=oldest`);
        }
        if (this.adSort == "newest") {
          queryArray.push(`sort=newest`);
        }
        if (this.adSort == "most likes") {
          queryArray.push(`sort=likes`);
        }
        if (this.adSort == "most comments") {
          queryArray.push(`sort=comments`);
        }
        if (this.adSort == "most views") {
          queryArray.push(`sort=views`);
        }
        if (queryArray.length > 0) {
          let queryString = queryArray.join("&");
          newUrl = `${newUrl}/?${queryString}`;
        }
        this.$router.push(newUrl);
        this.loadAds();
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },

    async discountSearch() {
      try {
        console.log("SEARCH FIELD", this.keywordSearchField);
        let newUrl = `/sales/ad-search`;
        let queryArray = [];
        this.currentPage = 1;
        if (typeof this.keywordSearchField !== "undefined") {
          queryArray.push(`q=${this.keywordSearchField}`);

          let searchType = this.$route.query.type;
          if (typeof searchType == "undefined") {
            searchType = "keyword";
          }
          if (searchType == "undefined") {
            searchType = "keyword";
          }
          queryArray.push(`type=${searchType}`);
        }

        let sortQuery;
        if (this.adSort == "newest") {
        }
        if (this.adSort == "oldest") {
          queryArray.push(`sort=oldest`);
        }
        if (this.adSort == "newest") {
          queryArray.push(`sort=newest`);
        }
        if (this.adSort == "most likes") {
          queryArray.push(`sort=likes`);
        }
        if (this.adSort == "most comments") {
          queryArray.push(`sort=comments`);
        }
        if (this.adSort == "most views") {
          queryArray.push(`sort=views`);
        }
        if (queryArray.length > 0) {
          let queryString = queryArray.join("&");
          newUrl = `${newUrl}/?${queryString}`;
        }
        this.$router.push(newUrl);
        this.adList = [];

        await this.loadAds();
      } catch (err) {
        console.log("ERR:", err);
      }
    },

    async loadAds() {
      try {
        let self = this;
        this.searchActive = true;

        let adSearchUrl = `${adSearchApi}/?usertoken=${this.auth}`;
        if (typeof this.$route.query.q !== "undefined") {
          let searchQuery = this.$route.query.q.trim();
          if (searchQuery !== "") {
            adSearchUrl = `${adSearchUrl}&q=${this.$route.query.q}`;
          }
        }
        let searchType = this.$route.query.type;
        if (typeof searchType == "undefined") {
          searchType == "keyword";
        }
        if (searchType == "undefined") {
          searchType == "keyword";
        }
        adSearchUrl = `${adSearchUrl}&type=${searchType}`;

        if (typeof this.$route.query.sort !== "undefined") {
          adSearchUrl = `${adSearchUrl}&sortby=${this.$route.query.sort}`;
        }
        if (typeof this.$route.query.sort == "oldest") {
          adSearchUrl = `${adSearchUrl}&sortby=active&order=old`;
        }
        if (typeof this.$route.query.sort == "newest") {
          adSearchUrl = `${adSearchUrl}&sortby=active&order=new`;
        }
        if (typeof this.$route.query.sort == "comments") {
          adSearchUrl = `${adSearchUrl}&sortby=comments`;
        }
        if (typeof this.$route.query.sort == "likes") {
          adSearchUrl = `${adSearchUrl}&sortby=likes`;
        }
        if (typeof this.$route.query.sort == "views") {
          adSearchUrl = `${adSearchUrl}&sortby=views`;
        }
        if (typeof this.$route.query.page !== "undefined") {
          adSearchUrl = `${adSearchUrl}&page=${this.$route.query.page}`;
        }
        console.log("HERE IS THE AD SEARCH URL: ", adSearchUrl);
        let adSearchResponse = await axios.get(adSearchUrl);
        if (adSearchResponse.data.success == true) {
          this.searchActive = false;
          this.adList = adSearchResponse.data.result.map((x) => {
            try {
              if (typeof x.imageUrlCache == "undefined") {
                //this.imageLoadCache(x.shortcode);
                return [];
              }
              let formattedPost = JSON.parse(JSON.stringify(x));

              if (typeof x.commentCount !== "undefined") {
                formattedPost.commentCount = Number(x.commentCount);
                formattedPost.commentCountString = x.commentCount;
              }
              if (typeof x.likeCount !== "undefined") {
                formattedPost.likeCount = Number(x.likeCount);
                formattedPost.likeCountString = x.likeCount;
              }
              if (typeof x.viewCount !== "undefined") {
                formattedPost.viewCount = Number(x.viewCount);
                formattedPost.viewCountString = x.viewCount;
              }

              return formattedPost;
            } catch (err) {
              console.log("THERE WAS AN ERROR:", err);
              return [];
            }
          });

          this.adList = _.flatten(this.adList);
          console.log(" ADLIST RESULTS:", this.adList);
          this.searchData = adSearchResponse.data;
          this.pageCount = Math.floor(this.searchData.count / 100) + 1;
          console.log("PAGE COUNT:", this.pageCount);
          this.adCount = this.searchData.count;
          if (!isNaN(this.$route.query.page)) {
            this.currentPage = Number(this.$route.query.page);
          }
          this.paginationArray = [];
          this.paginationArray.push(this.currentPage);
          console.log("PAGINATION ARRAY CLEAN:", this.paginationArray);
          if (this.pageCount > 1) {
            var i;
            for (i = this.currentPage + 1; i < this.currentPage + 3; i++) {
              if (i < this.pageCount) {
                console.log("UP:", i);
                await this.paginationArray.push(i);
                console.log("PAGINATION UP ARRAY:", this.paginationArray);
              }
            }
            var j;
            for (j = this.currentPage - 1; j > this.currentPage - 3; j--) {
              if (j > 0) {
                console.log("DOWN:", j);
                await this.paginationArray.push(j);
                console.log("PAGINATION DOWN ARRAY:", this.paginationArray);
              }
            }
          }
          if (this.currentPage + 1 <= this.pageCount + 1) {
            this.nextPage = this.currentPage + 1;
          }
          if (this.currentPage - 1 > 1) {
            this.prevPage = this.currentPage - 1;
          }
          console.log("NEXT PAGE:", this.nextPage);
          console.log("PREV PAGE:", this.prevPage);
          this.paginationArray = _.sortBy(this.paginationArray);
          console.log("PAGINATION", this.paginationArray);
          await adSearchResponse.data.result.map((x, index) => {
            try {
              if (typeof x.imageUrlCache == "undefined") {
                console.log(x);
                return setTimeout(function () {
                  self.imageLoadCache(x.shortcode);
                }, 500 * index);
              }
            } catch (err) {
              console.log("THERE WAS AN ERROR:", err);
            }
            return;
          });
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async imageLoadCache(shortcode) {
      try {
        let postCacheUrl = `${adCacheApi}/?usertoken=${this.auth}&shortcode=${shortcode}`;
        console.log("POST CACHE:", postCacheUrl);
        let postCacheResponse = await axios.get(postCacheUrl);
        console.log(`LOADING ${shortcode}`, postCacheResponse.data);
        if (postCacheResponse.data.success == true) {
          return postCacheResponse.data.imageUrlCache;
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },

    async loadPageContent() {
      //await this.loadCampaignDetails();

      if (this.$route.query.sort == "views") {
        this.adSort = "most views";
      }
      if (this.$route.query.sort == "oldest") {
        this.adSort = "oldest";
      }
      if (this.$route.query.sort == "likes") {
        this.adSort = "most likes";
      }
      if (this.$route.query.sort == "comments") {
        this.adSort = "most comments";
      }
      await this.loadAds();
    },
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  },
};
</script>

<style scoped>
.post-item {
  float: left;
  padding: 10px;
  height: 250px;
  width: 250px;
  overflow: hidden;
  cursor: pointer !important;
}
.overlay p {
  color: white;
}
.overlay i {
  font-size: 40px;
  color: white;
}
.overlay-stats {
  margin: 0;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.iframe-center {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  width: 300px;
}
.hashtag-badge {
  margin: 3px;
  float: left;
}
.hashtag-badge :hover {
  cursor: pointer;
}
.post-click {
  cursor: pointer;
}
html {
  overflow-y: scroll !important;
}
</style>